import api from './api';

/**
 * Feature-flag API.
 *
 * User-facing endpoints live under /api/v1/** and are wrapped in ApiResponse,
 * so they unwrap `response.data.data`. Admin endpoints live under /api/admin/**
 * and return the bare payload (`response.data`).
 */
const featureService = {
  // ── User-facing ────────────────────────────────────────────────
  /** Feature keys enabled for the current user (for the useFeature hook). */
  getEnabledFeatures: async () => {
    const response = await api.get('/api/v1/features');
    return response.data.data;
  },

  // ── Admin ──────────────────────────────────────────────────────
  /** All flags with their full targeting configuration. */
  adminGetAllFlags: async () => {
    const response = await api.get('/api/admin/feature-flags');
    return response.data;
  },

  /** Create or update a flag's targeting (upsert by key). */
  adminUpsertFlag: async (key, dto) => {
    const response = await api.put(`/api/admin/feature-flags/${key}`, dto);
    return response.data;
  },
};

export default featureService;
